import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { getActiveMailListFilterPropsForSelectedView } from 'mini-mail-list-filter';
import { shouldShowMailListHeaderForFolderId } from 'mini-mail-list-view/lib/utils/mailList/shouldShowMailListHeaderForFolderId';

/**
 * Return the filters to be shown in the Primary Header
 * @param selectedFolderId
 * @returns []
 */
export const getMailFilters = (selectedFolderId: string) => {
    if (!selectedFolderId) {
        return [];
    }

    // If the MailListHeader (secondary header) is shown, then don't show mail filters in primary header
    if (shouldShowMailListHeaderForFolderId(selectedFolderId)) {
        return [];
    }

    const { activeViewFilter, icon, label, ariaLabel, isPressed } =
        getActiveMailListFilterPropsForSelectedView(getCurrentSelectedTableView());

    return [
        {
            activeViewFilter,
            ariaLabel: ariaLabel || label,
            icon,
            isPressed,
        },
    ];
};
